var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Linkedin35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "35px",
    height: "35px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#e6d3e0",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.72266,10c-7.162,0 -7.72266,0.56066 -7.72266,7.72266v14.55469c0,7.162 0.56066,7.72266 7.72266,7.72266h14.55469c7.162,0 7.72266,-0.56066 7.72266,-7.72266v-14.50781c0,-7.206 -0.56353,-7.76953 -7.76953,-7.76953zM17,11h16c5.565,0 6,0.435 6,6v16c0,5.565 -0.435,6 -6,6h-16c-5.565,0 -6,-0.435 -6,-6v-16c0,-5.565 0.435,-6 6,-6zM17.87695,14.87891c-1.222,0 -2.21289,0.98799 -2.21289,2.20898c0,1.221 0.98989,2.21289 2.21289,2.21289c1.219,0 2.20898,-0.99189 2.20898,-2.21289c0,-1.219 -0.98998,-2.20898 -2.20898,-2.20898zM29.44922,20.74219c-1.845,0 -3.08089,1.01366 -3.58789,1.97266h-0.05078v-1.66797h-3.63867v12.20313h3.79102v-6.03711c0,-1.591 0.30139,-3.13477 2.27539,-3.13477c1.945,0 1.97266,1.82033 1.97266,3.23633v5.93555h3.78906v-6.69336c0,-3.286 -0.71078,-5.81445 -4.55078,-5.81445zM15.97852,21.04688v12.20313h3.79297v-12.20312z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Linkedin35);
export default __webpack_public_path__ + "static/media/icons8-linkedin-35.4d433be85f8d8f9cf299b1632f7356b5.svg";
export { ForwardRef as ReactComponent };